import React, { useState } from "react";

import OutlineButton from "../../components/customButtons/OutlineButton";
import Loader from "../../components/loader";
import useSiteImage from "../../hooks/useSiteImage";
import { SITE_IMAGES } from "../../constants/siteImages";

const Background = ({ onStartNowClick }) => {
  const [isLoading, setIsLoading] = useState(true);
  const image = useSiteImage(SITE_IMAGES.HOME_BACKGROUND, "100vw");

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = () => {
    setIsLoading(false);
  };

  return (
    <div className="flex flex-col justify-center overflow-hidden h-full">
      <div className="relative h-[90%] flex-1">
        {isLoading && (
          <Loader className={"absolute top-0 left-0 h-full w-full"} />
        )}
        <img
          alt="Background"
          {...image}
          className={`h-full w-full shrink-0 object-cover ${
            isLoading ? "hidden" : "block"
          }`}
          onLoad={handleImageLoad}
          onError={handleImageError}
        />
      </div>
      <div className="mx-auto p-5">
        <OutlineButton className="px-10 py-2" onClick={onStartNowClick}>
          Start Now
        </OutlineButton>
      </div>
    </div>
  );
};

export default Background;
